const navigationRef = {navigate: null};

const navigate = (path, params = {}) => {
    if (navigationRef.navigate) {
        navigationRef.navigate(path, {replace: true, ...params});
    } else {
        console.warn('Navigate function not initialized yet.');
    }
};

export default {
    navigationRef,
    navigate,
};
